import { render, staticRenderFns } from "./ProjectLeadList.vue?vue&type=template&id=5ef629bb&"
import script from "./ProjectLeadList.vue?vue&type=script&lang=js&"
export * from "./ProjectLeadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports